import { render, staticRenderFns } from "./ControleChamados.vue?vue&type=template&id=7bbc1ea2&"
import script from "./ControleChamados.vue?vue&type=script&lang=js&"
export * from "./ControleChamados.vue?vue&type=script&lang=js&"
import style0 from "./ControleChamados.vue?vue&type=style&index=0&id=7bbc1ea2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports